// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';

if (typeof Object.create != 'function') {
    Object.create = (function (undefined) {
        var Temp = function () {
        };
        return function (prototype, propertiesObject) {
            if (prototype !== Object(prototype) && prototype !== null) {
                throw TypeError('Argument must be an object, or null');
            }
            Temp.prototype = prototype || {};
            if (propertiesObject !== undefined) {
                Object.defineProperties(Temp.prototype, propertiesObject);
            }
            var result = new Temp();
            Temp.prototype = null;
            // to imitate the case of Object.create(null)
            if (prototype === null) {
                result.__proto__ = null;
            }
            return result;
        };
    })();
}
import Vue from 'vue';
import App from './App';
import NewsletterForm from './components/newsletter/Form';
import GoogleMapContainer from './components/google-map/Map';
import router from './router';
import Router from 'vue-router';
import store from './store';
import * as VueGoogleMaps from 'vue2-google-maps';
import {register as registerFilters} from './filter';

registerFilters();

Vue.config.productionTip = false

Vue.use(Router);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyB9ZO9OmiBORQvs_5f1ku3m6cREOU5e1cE',
        libraries: 'places'
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})

new Vue({
    el: '#newsletter-app',
    components: {NewsletterForm},
    template: '<newsletter-form/>'
})

new Vue({
    el: '#google-map-app',
    components: {GoogleMapContainer},
    data: {
        lat: null,
        lng: null
    },
    beforeMount: function () {
        if (this.$el.attributes.length) {
            this.lat = parseFloat(this.$el.attributes['data-lat'].value);
            this.lng = parseFloat(this.$el.attributes['data-lng'].value);
        }
    },
    template: '<google-map-container :coords="{ lat, lng }" v-if="lat && lng" />'
})



// WEBPACK FOOTER //
// ./src/main.js